import { is } from "app/pages/sales-intelligence/utils/type-guards";

import type { ExpandedRowVariant } from "../types/expanded-row";
import type { TableRowKey } from "../types/table";

export const isSameExpandedRowVariant = (
    current: ExpandedRowVariant | undefined,
    next: ExpandedRowVariant,
): boolean => {
    if (is.undefined(current) || current.kind !== next.kind) {
        return false;
    }

    if (current.kind === "crm-records" && next.kind === "crm-records") {
        return current.integrationProvider === next.integrationProvider;
    }

    return true;
};

export const isRowExpanded = (
    expandedRowKeys: readonly TableRowKey[],
    expandedRowVariant: ExpandedRowVariant | undefined,
    key: TableRowKey | undefined,
    variant: ExpandedRowVariant,
): boolean =>
    !is.undefined(key) && expandedRowKeys.includes(key) && isSameExpandedRowVariant(expandedRowVariant, variant);
